<div
    id="featured-photo-container"
    class="transition-all duration-75 flex flex-col justify-center items-center gap-2"
  >
    <section
      id="featured-photo-carousal"
      class="flex justify-center items-center w-full gap-4"
    >
      <div
        id="featured-photo-left-icon"
        class="neptune-carousal-button"
        (click)="showPrevSlide()"
      >
        <img
          alt="Left Arrow"
          src="/assets/shared-icons/neptune-icon-blue-left-chevron.svg"
          class="w-5 h-5 scale-75"
        />
      </div>

      <div class="w-50 h-50">
        <img
          class="w-full h-full object-cover"
          [src]="serviceInsightsPhotoObject.photoInfo[currentSlideIndex].url"
          alt="Photo"
        />
      </div>

      <div
        id="featured-photo-right-icon"
        class="neptune-carousal-button"
        (click)="showNextSlide()"
      >
        <img
          alt="Right Arrow"
          src="/assets/shared-icons/neptune-icon-blue-chevron-right.svg"
          class="w-5 h-5 scale-150"
        />
      </div>
    </section>
    <section id="featured-photo-details" class="flex flex-col gap-1 w-full">
      <span id="featured-photo-description" class="text-sm self-center">{{
        serviceInsightsPhotoObject.photoInfo[currentSlideIndex].description
      }}</span>
      <span id="featured-photo-meta-info" class="text-xs self-center"
        >{{ serviceInsightsPhotoObject.endDate | date: "longDate" }} |
        {{ serviceInsightsPhotoObject.ecolabRep }}</span
      >
    </section>
    <section
      id="featured-photo-pager"
      class="flex justify-center items-center w-full"
    >
      <div class="text-xs text-white py-1 px-2 rounded-full bg-black/50">
        {{ currentSlideIndex + 1 }} /
        {{ serviceInsightsPhotoObject.photoInfo.length }}
      </div>
    </section>
  </div>

